import { useAppSelector } from '@/Hook/hooks'
import { toggleLoader } from '@/Redux/Ducks/loaderSlice';
import { setGlobalMessage } from '@/Redux/Ducks/messageSlice';
import { setUserObject } from '@/Redux/Ducks/userSlice';
import { requestUpdatePassword } from '@/Redux/Sagas/Requests/user';
import { AlignInput } from 'AlignComponents';
import React, { useState } from 'react'
import { Button, Col, Form, Row } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import Modal from '../Modal'

function NewPasswordPrompt() {

  const dispatch = useDispatch();
  const userInfo = useAppSelector(state => state.User.user);
  const showPrompt = userInfo.resetpasswordonlogin;
  const [model, setModel] = useState({
    oldPassword: "",
    newPassword: "",
    conformPassword: "",
  });
  const [validated, setValidated] = useState(false);

  const closePrompt = () => {

  }

  const updateModel = (key: string, value: string) => {
    setModel({
      ...model,
      [key]: value
    });
  }

  const updatePassword = async (e: any) => {
    const form = e.currentTarget;
    e.preventDefault();
    e.stopPropagation();
    setValidated(true);
    try {
      if (form.checkValidity() === true) {

        dispatch(toggleLoader(true));

        await requestUpdatePassword(model.oldPassword, model.newPassword);
        dispatch(setUserObject({ user: { ...userInfo, resetpasswordonlogin: false } }))

        resetState();
        dispatch(setGlobalMessage({ message: "Password is Updated" }));
      }

    }
    catch (ex) {
      dispatch(setGlobalMessage({ error: ex }));
    }
    finally {
      dispatch(toggleLoader(false));
    }
  }

  const resetState = () => {
    setModel({
      oldPassword: "",
      newPassword: "",
      conformPassword: "",
    });
    setValidated(false);
  }

  return (
    <Modal
      heading="Update Password"
      show={showPrompt}
      close={closePrompt}
      footer={
        <Button form="updatePasswordModal" variant="success" type="submit">
          Update
        </Button>
      }
    >
      <Form id="updatePasswordModal" noValidate validated={validated} onSubmit={updatePassword}>
        <Form.Group className="mb-2" controlId="oldPassword" as={Row}>
          <Form.Label column sm="4">Old Password</Form.Label>
          <Col sm="8">
            <Form.Control
              required
              type="password"
              name="oldPassword"
              value={model.oldPassword}
              onChange={(e: any) => updateModel("oldPassword", e.target.value)}
            />
          </Col>
        </Form.Group>
        <Form.Group className="mb-2" controlId="newPassword" as={Row}>
          <Form.Label column sm="4">New Password</Form.Label>
          <Col sm="8">
            <Form.Control
              required
              type="password"
              name="newPassword"
              value={model.newPassword}
              onChange={(e: any) => updateModel("newPassword", e.target.value)}
              minLength={6}
              isInvalid={
                validated && model.newPassword.length < 6
              }
            />
            <Form.Control.Feedback type="invalid">
              Password must be at least 6 characters long.
            </Form.Control.Feedback>
          </Col>
        </Form.Group>
        <Form.Group className="mb-2" controlId="conformPassword" as={Row}>
          <Form.Label column sm="4">Conform Password</Form.Label>
          <Col sm="8">
            <Form.Control
              required
              type="password"
              name="conformPassword"
              value={model.conformPassword}
              onChange={(e: any) => updateModel("conformPassword", e.target.value)}
              minLength={6}
              pattern={model.newPassword}
              isInvalid={
                validated &&
                model.conformPassword !== model.newPassword
              }
            />
            <Form.Control.Feedback type="invalid">
              Passwords do not match.
            </Form.Control.Feedback>
          </Col>
        </Form.Group>
      </Form>
    </Modal>
  )
}

export default NewPasswordPrompt